export const primaryColor = '#6257d2';

export const rub = '₽';
